import { IconButton, Modal } from "@mui/material";
import { useState } from "react";
import { IoMdClose } from "react-icons/io";
import Slider from "react-slick";
import { motion, AnimatePresence } from "framer-motion";

export default function AboutSlider({ data = null }) {

    const [selectedImage, setSelectedImage] = useState(null);
    const [modalOpen, setModalOpen] = useState(false)

    const openModal = (image) => {
        setSelectedImage(image);
        setModalOpen(true);
    };

    const closeModal = () => {
        setSelectedImage(null);
        setModalOpen(false);
    };

    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 3.5,
        slidesToScroll: 1,
        arrows: true,
        nextArrow: <NextArrow />,
        swipeToSlide: true,
        centerMode: false,
        responsive: [
            {
                breakpoint: 1390,
                settings: {
                    slidesToShow: 2.5,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2.1,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1.1,
                    slidesToScroll: 1,
                },
            },
        ],
    }

    const imageVariants = {
        hidden: { opacity: 0, scale: 0.9 },
        visible: { 
            opacity: 1, 
            scale: 1,
            transition: {
                duration: 0.5,
                ease: [0.22, 1, 0.34, 1]
            }
        },
        hover: {
            scale: 1.05,
            transition: {
                duration: 0.3,
                ease: "easeOut"
            }
        }
    };

    const modalVariants = {
        hidden: { opacity: 0, scale: 0.8 },
        visible: { 
            opacity: 1, 
            scale: 1,
            transition: {
                duration: 0.4,
                ease: [0.22, 1, 0.34, 1]
            }
        },
        exit: {
            opacity: 0,
            scale: 0.8,
            transition: {
                duration: 0.3,
                ease: "easeIn"
            }
        }
    };

    return (
        <div className=" py-[34px] lg:mt-[135px] lg:pb-[143px] w-full overflow-hidden">
            <div className="relative">
                <Slider {...settings} >
                    {data && data.length > 0 && data.map((image, index) => {
                        return (
                            <motion.div
                                key={index}
                                onClick={() => { openModal(image.image) }}
                                className="pr-4 cursor-pointer lg:pr-[34px] focus-visible:outline-0 w-full h-full"
                                initial="hidden"
                                animate="visible"
                                custom={index}
                            >
                                <img loading='eager' className='w-full h-full  lg:min-w-[380px] aspect-[1.53/1] lg:aspect-square object-cover rounded-2xl ' src={image.image} alt="" />
                            </motion.div>
                        )
                    })}
                </Slider>
            </div>
            <AnimatePresence>
                {modalOpen && (
                    <Modal open={modalOpen} onClose={closeModal}>
                        <motion.div 
                            className='flex justify-center items-center h-screen bg-black/50 bg-opacity-75'
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            exit={{ opacity: 0 }}
                            transition={{ duration: 0.3 }}
                        >
                            <motion.div 
                                className='w-[90%] lg:w-[50%] relative p-4 bg-[#1f222a] rounded-lg'
                                variants={modalVariants}
                                initial="hidden"
                                animate="visible"
                                exit="exit"
                            >
                                <IconButton 
                                    className='absolute top-0 left-[90%] lg:left-[96%]' 
                                    onClick={closeModal}
                                    whileHover={{ scale: 1.1 }}
                                    whileTap={{ scale: 0.9 }}
                                >
                                    <IoMdClose className='text-white' />
                                </IconButton>
                                <img className=" object-cover " src={selectedImage} alt="" />
                            </motion.div>  
                        </motion.div>
                    </Modal>
                )}
            </AnimatePresence>
        </div>
    )
}

const NextArrow = (props) => {
    const { onClick } = props;
    return (
        <motion.div 
            className="slider_custom_next_arrow_shadow cursor-pointer w-[161px] h-full flex items-center justify-end top-[0%]" 
            onClick={onClick}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
        >
            <div className="">
                <div className="slider_custom_next_arrow">
                    <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M7.42467 17.225C7.26634 17.225 7.10801 17.1667 6.98301 17.0417C6.74134 16.8 6.74134 16.4 6.98301 16.1583L12.4163 10.725C12.8163 10.325 12.8163 9.67502 12.4163 9.27502L6.98301 3.84168C6.74134 3.60002 6.74134 3.20002 6.98301 2.95835C7.22467 2.71668 7.62467 2.71668 7.86634 2.95835L13.2997 8.39168C13.7247 8.81668 13.9663 9.39168 13.9663 10C13.9663 10.6083 13.733 11.1833 13.2997 11.6083L7.86634 17.0417C7.74134 17.1583 7.58301 17.225 7.42467 17.225Z"
                            fill="#F9F9F9"
                        />
                    </svg>
                </div>
            </div>
        </motion.div>
    );
};